const fromArrayToString = (value) => {
  if (!value && value?.length === 0) {
    return void 0;
  }
  const stringValue = Array.isArray(value) ? value[0] : value;
  return stringValue ? stringValue : void 0;
};
export {
  fromArrayToString
};
//# sourceMappingURL=from-array-to-string.js.map
